module.exports = __webpack_public_path__ + "img/cbanner.58a20d0f.png";